import * as yup from 'yup';

export const ModalEmployeeSchema = yup.object({
  employeeName: yup
    .string()
    .required('Обязательное поле')
    .max(33, 'Имя пользователя должно содержать не более 33-х символов'),
  changePassword: yup.boolean().default(true),
  password: yup.string().when('changePassword', {
    is: true,
    then: (schema) => schema.required('Введите пароль'),
    otherwise: (schema) => schema.nullable().notRequired()
  })
});
